import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-reveal';
import { Section } from '@/features/new-landing-page/components/section';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { CaseStudiesContent } from '@/features/new-landing-page/pages/homepage-content';
import { VSpace } from '@/components/spacing';
import { StrapiMetric } from '@/features/strapi/components/metric';
import { breakpoints } from '@/components/responsive';
import { CaseStudiesWithProgress } from '@/features/new-landing-page/components/case-studies-with-pb';

export function CaseStudiesSection({ noCta }: { noCta?: boolean }) {
  return (
    <Section>
      <VSpace value={8} mobileValue={4} />
      <StrapiTextual {...CaseStudiesContent.title} />
      <Fade bottom>
        <CaseStudiesWithProgress data={CaseStudiesContent.caseStudies} />
      </Fade>
      <VSpace value={3} />
      <StrapiTextual {...CaseStudiesContent.growthTitle} />
      <VSpace value={3} mobileValue={1} />
      <MetricsWrapper>
        <Fade bottom>
          {CaseStudiesContent.growthMetrics.map((metric) => (
            <StrapiMetric key={metric.metricName} {...metric} />
          ))}
        </Fade>
      </MetricsWrapper>
      <VSpace value={5} />
      {!noCta && (
        <>
          <CTA>
            <StrapiTextual {...CaseStudiesContent.growthCta} />
          </CTA>
          <StrapiTextual {...CaseStudiesContent.growthSubtitle} />
        </>
      )}
      <VSpace value={5} mobileValue={1} />
    </Section>
  );
}

const CTA = styled.div`
  && > * {
    padding: 1.5rem 6rem;
    font-size: 1.8rem;
  }
  margin-bottom: 5rem;
`;

const MetricsWrapper = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
  justify-items: center;
  align-content: center;

  ${breakpoints.down(`md`)} {
    grid-gap: 6rem;
    grid-template-columns: 1fr;
  }
`;
